import styled from "styled-components";
import { device } from "../../styles/breakpoints";

export const RoleTest = styled.div`
  color: #000;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Verizon NHG eDS;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  padding: 0 16px;

  @media ${device.tablet} {
    font-size: 20px;
    line-height: 24px;
    padding: 0;
  }
`;

export const RoleButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: var(--space-3X, 12px);
  width: auto;
  height: auto;
`;

export const ContainerButtons = styled.div`
  display: flex;
  width: 100%;
  padding: 0 16px;
  flex-direction: column;
  gap: 12px;
  justify-content: flex-start;
  align-items: stretch;

  @media ${device.tablet} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  }

  @media ${device.desktop} {
    max-width: 1363px;
  }
`;

export const RoleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  height: auto;

  @media ${device.tablet} {
    gap: 20px;
  }

  @media ${device.desktop} {
    max-width: 1363px;
    gap: 24px;
  }
`;

export const AddRoleContainerWithButtons = styled.div`
  display: flex;
  width: 100%;
  padding: 0 16px;
  flex-direction: row;
  gap: 12px;
  justify-content: space-between;
  align-items: center;

  @media ${device.tablet} {
    padding: 0;
  }

  @media ${device.desktop} {
    max-width: 1363px;
  }
`;

export const AddRoleHeading = styled.h1`
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG DS;
  font-size: 28px;
  font-style: normal;
  font-weight: 300;
  line-height: 32px;
  letter-spacing: 0.25px;
  width: auto;
  height: auto;
  text-align: left;
  margin: 0;
  flex-shrink: 1;
  min-width: 0;

  @media ${device.tablet} {
    font-size: 32px;
    line-height: 36px;
  }
`;

export const SaveButton = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--space-3X, 12px);
  width: auto;
  height: auto;
  flex-shrink: 0;
`;

export const RoleListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;
  gap: 16px;

  @media ${device.tablet} {
    padding: 0;
  }

  @media ${device.desktop} {
    width: 50%;
  }
`;

export const BreadcrumbContainer = styled.div`
  display: flex;
  padding: 0 16px;

  @media ${device.tablet} {
    padding: 0;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 0 16px;

  @media ${device.tablet} {
    flex-direction: row;
    gap: var(--space-3X, 12px);
    padding: 0;
  }
`;

export const RoleInputWrapper = styled.div`
  flex: 1;
  width: 100%;

  input {
    width: 100% !important;
    height: 64px;
    border-color: black;
    border-left-width: 0;
    border-top-width: 0;
    border-right-width: 0;
    border-radius: 0;
  }

  @media ${device.tablet} {
    &.role-name-input {
      flex: 0 0 auto;
      width: 328px;
    }

    &.role-description-input {
      flex: 1;
      min-width: 0;
    }
  }

  @media ${device.desktop} {
    &.role-description-input {
      max-width: 1008px;
    }

    &.full-width-input {
      max-width: 1336px;
    }
  }
`;